
import { BrowserRouter } from 'react-router-dom';
import { AppRoutes } from './router';
import ExitIntentPopup from './components/feature/ExitIntentPopup';
import StickyCtaBar from './components/feature/StickyCtaBar';

function App() {
  return (
    <BrowserRouter basename={__BASE_PATH__}>
      <div className="min-h-screen bg-gray-50">
        <AppRoutes />
        <ExitIntentPopup />
        <StickyCtaBar />
      </div>
    </BrowserRouter>
  );
}

export default App;
